import { cn } from '@forest/shared'
import { type Item } from '~/features/reward-flow/store'

export function Indicator({
  items,
  currentIndex,
}: {
  items: Item[]
  currentIndex: number
}) {
  return (
    <div className="flex h-12 items-center justify-center space-x-3">
      {items.length > 1 &&
        items.map((_, index) => (
          <span
            key={index}
            className={cn('text-white', index !== currentIndex && 'opacity-70')}
          >
            {currentIndex >= index ? <CheckIcon /> : <DotIcon />}
          </span>
        ))}
    </div>
  )
}

function CheckIcon({ className }: { className?: string }) {
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1.6875 6.54922L5.225 10.0867L12.3125 3.01172"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

function DotIcon({ className }: { className?: string }) {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="6" cy="6.5498" r="6" fill="currentColor" />
    </svg>
  )
}
